var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 134,
    viewBox: "0 0 348 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.84 47.8127L0 76.719V114C0 125.046 8.95431 134 20 134H318C334.569 134 348 120.569 348 104V25.0151C346.732 24.2279 344.886 23.9649 344.102 23.9033C338 23.4236 334.5 28 329.626 32.2417L329.565 32.2944C328.124 33.5493 324.52 36.6888 317.933 36.6888C311.251 36.6888 306.611 33.7241 305.126 32.2417L282.854 8.89426C279.885 5.92951 273.389 0 266.15 0C258.912 0 253.158 5.92951 250.56 8.89426L147.552 108.405C145.882 110.258 140.759 113.964 133.632 113.964C126.505 113.964 121.382 110.258 119.712 108.405L60.1344 45.0332C58.0928 42.8097 52.1165 38.3625 44.544 38.3625C36.9715 38.3625 30.2528 44.6626 27.84 47.8127Z",
    fill: "url(#paint0_linear_4_436)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_436",
    x1: 174,
    y1: -10,
    x2: 174,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveDesktop);
export default __webpack_public_path__ + "static/media/wave-desktop.2fe84cb63b23b6514f931746ee12461e.svg";
export { ForwardRef as ReactComponent };